import { MixpanelPolicyPayload } from './generic-entity-types';

export interface PolicyStartDateMovedPayload extends MixpanelPolicyPayload {}

export function generatePolicyStartDateMovedProperties(
  payload: PolicyStartDateMovedPayload,
): PolicyStartDateMovedPayload {
  return payload;
}
